(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "lodash/assign", "lodash/each"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("lodash/assign"), require("lodash/each"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.each);
    global.importScript = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _assign, _each) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = importScript;
  _assign = _interopRequireDefault(_assign);
  _each = _interopRequireDefault(_each);
  var KEY = "_qxscriptImportsCache_23713";
  var caches = typeof window === "undefined" ? {} : window[KEY] || (window[KEY] = {});

  function importScript(url, options) {
    options = (0, _assign["default"])({}, options);
    return new Promise(function (resolve, reject) {
      var cacheKey = typeof options.cache === "string" ? options.cache : url;
      caches[cacheKey] = caches[cacheKey] || {
        ok: false,
        pendings: [],
        isPending: false
      };

      if (options.cache) {
        if (caches[cacheKey].ok) {
          return resolve(null);
        } else if (caches[cacheKey].isPending) {
          caches[cacheKey].pendings.push([resolve, reject]);
          return;
        }
      }

      var el = document.createElement("script");

      if (options.defer) {
        el.defer = true;
      }

      if (options.async) {
        el.async = true;
      }

      caches[cacheKey].isPending = true;

      el.onload = function () {
        el.onload = null; // resolve pending.

        setTimeout(function () {
          (0, _each["default"])(caches[cacheKey].pendings, function (fns) {
            fns[0](null);
          });
          caches[cacheKey].ok = true;
          caches[cacheKey].isPending = false;
          caches[cacheKey].pendings = [];
          return resolve(null);
        }, 1);
      };

      el.onerror = function (err) {
        el.onerror = null;
        var retErr = new Error(typeof err == "string" ? err : "script load error"); // reject pendings.

        (0, _each["default"])(caches[cacheKey].pendings, function (fns) {
          fns[1](retErr);
        });
        caches[cacheKey] = undefined;
        return reject(retErr);
      };

      document.getElementsByTagName("head")[0].appendChild(el);
      el.src = url;
    });
  }
});
//# sourceMappingURL=importScript.js.map